import renderAndEnableListingTiles from '../listing_tile_rendering/listingTileRenderer'
import { initiateSimilarSearch, buildFilters } from '../../utils/search/helpers'
import { onVisible } from '../utils'

export default function initSimilarQueryModules () {
  const similarQuerySections = document.querySelectorAll('.vjs-algolia-similar-section')
  similarQuerySections.forEach(similarSection => {
    if (similarSection.dataset.lazyLoaded === 'true') {
      onVisible(similarSection, loadSimilarQueryListings)
    } else {
      loadSimilarQueryListings(similarSection)
    }
  })
}

function loadSimilarQueryListings (similarQuerySection) {
  const {
    listingId, listingTitle, productType, subProductType, subcategory
  } = similarQuerySection.dataset
  const filters = buildFilters({ listingId, productType, subProductType, subcategory })

  const hitsPerPage = 20 // enough to cover both the top and lower sections
  initiateSimilarSearch(listingTitle, hitsPerPage, filters).then(results => {
    const queryID = results.queryID ? results.queryID : ''
    results.hits.forEach((hit, index) => {
      hit.__position = index + 1
      hit.__queryID = queryID
    })

    renderSection(results, similarQuerySection)

    const secondarySimilarSection = document.getElementById('vjs-similar-listings-section')
    if (secondarySimilarSection !== similarQuerySection) {
      renderSection(results, secondarySimilarSection)
    }
  })
}

function renderSection (algoliaResults, section) {
  const { hitsPerPage } = section.dataset

  const hits = algoliaResults.hits.slice(0, hitsPerPage)

  renderAndEnableListingTiles(section, hits)
  import(/* webpackChunkName: "carousels" */ '../carousels').then(module => module.initPDPViewMoreCarousel(section))
}
